import { BaseApiRequest } from '@api/BaseApi';
import { objectToQuery } from '@api/helpers';
import { GEOGRAPHICAL_TYPES } from '@constants';

export const getCountries = (data, signal) => {
  const query = objectToQuery(data);
  return BaseApiRequest(signal, `/Country/Active?${query}`, 'ships');
};

export const getCountryDetail = (signal, countryId) => {
  return BaseApiRequest(signal, `/Country/CountryDetails/${countryId}`, 'geo');
};

export const getActivePorts = (data, signal) => {
  return BaseApiRequest(signal, `/lookup/activeLocations`, 'ships', 'Post', data);
};
export const getCountryPortStats = (data, signal) => {
  return BaseApiRequest(signal, `/PortCalls/Trend`, 'ships', 'POST', data);
};

export const getCountryTopPorts = (data, signal = null) => {
  const query = objectToQuery(data);
  return BaseApiRequest(signal, `/Country/GetTopCountryPorts?${query}`);
};
